import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { RootState } from '../reduxStore';
import { hideLoader, showLoader } from './loaderSlice';
import { showErrorSnackbar } from './snackbarSlice';
import { editLanguage } from '../../ApiServices/LanguageServices';
import { t } from 'i18next';
import { handleResponse } from '../../ApiServices/ApiHandler';

export const initialState = {
  value: { totalCount: -1, data: [{}] },
  loading: false,
  error: null,
  selectedValue: null,
  filter: [{}]
};

const languageSlice = createSlice({
  name: 'languages',
  initialState: initialState,
  reducers: {
    clearLanguageState(state: any) {
      state.value = initialState.value;
      state.loading = false;
      state.error = null;
      state.selectedValue = initialState.selectedValue;
      state.filter = initialState.filter;
    }
  },
  extraReducers: builder => {
    builder.addCase(modifyLanguage.fulfilled, (state: any, action: any) => {
      state.error = initialState.error;
      state.loading = initialState.loading;
      state.selectedValue = initialState.selectedValue;
      state.value = action?.payload?.data;
      state.sortDirection = action?.meta?.arg?.sortDirection;
      state.filter = action?.meta?.arg?.filter;
    });
    builder.addCase(modifyLanguage.rejected, (state: any, action: any) => {
      state.error = action?.payload?.error?.message;
      state.loading = false;
      state.selectedValue = initialState?.selectedValue;
    });
  }
});

export const languageState = (state: RootState) => state?.languages;
export const { clearLanguageState } = languageSlice.actions;
export default languageSlice.reducer;

export const modifyLanguage = createAsyncThunk(
  'languages/modifyLanguage',
  async (payload: any, { fulfillWithValue, rejectWithValue, dispatch }) => {
    try {
      dispatch(showLoader({ message: t('MODIFYING_LANGUAGE') }));
      let response = await editLanguage(payload);
      return await handleResponse(response, fulfillWithValue, rejectWithValue, dispatch);
    } catch (error) {
      dispatch(showErrorSnackbar({ message: error }));
      return rejectWithValue(error);
    } finally {
      dispatch(hideLoader());
    }
  }
);
